import {CategoryIconItem} from "../landing/CategoryItemIcon";

export const SubcategoryCarousel = ({subcategories, loading, title = "Shop by Category"}) => {
    if (!loading && (!Array.isArray(subcategories) || subcategories.length === 0)) return null;

    return (
        <>
            <h2 className="text-2xl font-black pt-dark-blue mb-6">{title}</h2>
            <div className="bg-white rounded-3xl border border-base-200 shadow-sm p-6 mb-12">
                <div className="relative">
                    <div className="flex gap-6 overflow-x-auto pb-4 no-scrollbar scroll-smooth">
                        {loading ? (
                            Array.from({length: 6}).map((_, i) => (
                                <div key={i} className="flex flex-col items-center gap-2 shrink-0 animate-pulse">
                                    <div className="w-16 h-16 rounded-full bg-base-200"/>
                                    <div className="h-3 w-14 bg-base-200 rounded"/>
                                </div>
                            ))
                        ) : (
                            subcategories.map((cat, idx) => (
                                <CategoryIconItem
                                    key={idx}
                                    name={cat.name}
                                    src={cat.image || cat.imageUrl}
                                    href={`/product-category/${cat.slug}?sort=customerReviewCount.desc`}
                                />
                            ))
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};